import React from "react";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { route } from '/@/app/routes';
import { observer } from "mobx-react";

import { SectionView } from '/@/app/views/FreeMeasurementsView/SectionView';
import { freeMeasurementsViewState } from '/@/app/views/FreeMeasurementsView/FreeMeasurementsViewState';


// Does not observe, but sets state
const SubViewNavigator = observer(({ state }) => {
    const { subpath } = useParams();

    //
    // Open section by URL subpath.
    //
    useEffect(() => {
        state.loadSection(subpath);
    }, [subpath]);

    //
    // Set URL subpath by opened section.
    //
    useEffect(() => {
        if (subpath === undefined && state.activeSection === null) {
            // Redirect the root to the first section
            state.loadDefaultSection();
        } else {
            // set URL
            const url = route(`/free/${state.activeSection}/`);
            window.history.replaceState(null, '', url);
        }
    }, [state.activeSection]);

    return <SectionView state={freeMeasurementsViewState} />;
});


export const freeMeasurementsRoutes = [
    {
        // root, to be redirected to first section
        // Makes subpath `undefined`!
        path: '',
        element: <SubViewNavigator state={freeMeasurementsViewState} />,
    },
    {
        path: ':subpath',  // specific section
        element: <SubViewNavigator state={freeMeasurementsViewState} />,
    },
]
